var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.25C2.25 5.97935 2.53973 6.67882 3.05546 7.19454C3.57118 7.71027 4.27065 8 5 8C5.72935 8 6.42882 7.71027 6.94454 7.19454C7.46027 6.67882 7.75 5.97935 7.75 5.25C7.75 4.52065 7.46027 3.82118 6.94454 3.30546C6.42882 2.78973 5.72935 2.5 5 2.5C4.27065 2.5 3.57118 2.78973 3.05546 3.30546C2.53973 3.82118 2.25 4.52065 2.25 5.25V5.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.5C0.5 12.3065 0.974106 11.1619 1.81802 10.318C2.66193 9.47411 3.80653 9 5 9C6.19347 9 7.33807 9.47411 8.18198 10.318C9.02589 11.1619 9.5 12.3065 9.5 13.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50058 2.94403C9.91582 2.67422 10.3962 2.52154 10.891 2.50212C11.3859 2.48269 11.8767 2.59724 12.3119 2.83366C12.747 3.07008 13.1102 3.41961 13.3631 3.84534C13.6161 4.27106 13.7493 4.75719 13.7489 5.25239C13.7485 5.74759 13.6144 6.23348 13.3607 6.65877C13.107 7.08405 12.7432 7.43295 12.3077 7.66862C11.8721 7.90428 11.381 8.01798 10.8863 7.99769C10.3915 7.97741 9.91135 7.82389 9.49658 7.55337",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.11134C10.659 8.96203 11.3432 8.9629 12.0019 9.11389C12.6605 9.26488 13.2768 9.56211 13.805 9.98358C14.3331 10.405 14.7597 10.9399 15.0532 11.5486C15.3466 12.1573 15.4993 12.8243 15.5 13.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.17bd3332.svg";
export { ForwardRef as ReactComponent };